const API_URL = process.env.REACT_APP_API_URL;
const urlBase64ToUint8Array = (base64String) => {
    // DÜZELTME: Gelen string'in geçerli olup olmadığını kontrol et
    if (!base64String || typeof base64String !== 'string') {
        throw new Error('Uint8Array\'e dönüştürmek için geçersiz base64 string.');
    }
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    try {
        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);
        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    } catch (error) {
        console.error("Base64 çözme hatası:", error);
        throw new Error("Geçersiz VAPID anahtarı formatı.");
    }
};

export const subscribeUserToPush = async () => {
    try {
        const swRegistration = await navigator.serviceWorker.ready;
        const response = await fetch(`${API_URL}/api/public/vapid-public-key`);
        
        // DÜZELTME: Cevabın başarılı olup olmadığını kontrol et
        if (!response.ok) {
            throw new Error('VAPID public key sunucudan alınamadı.');
        }

        const vapidPublicKey = await response.text();
        const convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey);

        const subscription = await swRegistration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: convertedVapidKey
        });
        return subscription;
    } catch (error) {
        console.error('Push aboneliği oluşturulamadı:', error);
        if (Notification.permission === 'denied') {
            alert('Tarayıcı ayarlarından bildirimlere izin vermeniz gerekmektedir.');
        }
        throw error;
    }
};